/* LACUS Cart Bundle — raggruppa visivamente line items con _BundleId nel cart drawer
   Caricato globalmente via theme.liquid, gira su qualsiasi pagina dove appare il drawer */
(function(){
  /* Inietta Formato/Dimensioni/Finitura dalle options_with_values nel cart drawer */
  function injectVariantOptions(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      if(!cart.items)return;
      cart.items.forEach(function(item){
        if(item.properties&&(item.properties['_Configuratore']||item.properties['Destinazione']||item.properties['Formato']))return;
        if(!item.options_with_values||item.options_with_values.length===0)return;
        if(item.variant_title==='Default Title')return;
        var card=null;
        if(item.key){
          var any=document.querySelector('[data-line-id="'+CSS.escape(item.key)+'"]');
          if(any) card=any.closest('.ultra-cart-search-item')||any;
        }
        if(!card)return;
        var ul=card.querySelector('.CartItem__PropertyList');
        if(!ul){
          var propDiv=card.querySelector('.ultra-cart-item-properties');
          if(!propDiv)return;
          ul=document.createElement('ul');ul.className='CartItem__PropertyList';
          propDiv.insertBefore(ul,propDiv.firstChild);
        }
        ul.querySelectorAll('[data-vondom-injected]').forEach(function(el){el.remove();});
        var refLi=null;
        ul.querySelectorAll('li').forEach(function(li){var l=li.querySelector('.cart-prop-label');if(l&&(l.textContent==='Colore Struttura'||l.textContent==='Colore Tessuto')&&!refLi)refLi=li;});
        var insertPoint=refLi||ul.firstChild;
        var nameMap={'Misura':'Dimensioni'};
        item.options_with_values.forEach(function(opt){
          if(!opt.value||opt.value==='Default Title')return;
          if(opt.value.toLowerCase()==='nessuno')return;
          if(item.properties&&item.properties[opt.name])return;
          var displayName=nameMap[opt.name]||opt.name;
          var li=document.createElement('li');li.className='CartItem__Property';li.setAttribute('data-vondom-injected','1');
          li.innerHTML='<span class="cart-prop-label">'+displayName+'</span><span class="cart-prop-value">'+opt.value+'</span>';
          ul.insertBefore(li,insertPoint);
        });
      });
    }).catch(function(){});
  }
  function findCardByKey(key){
    if(!key)return null;
    /* Match esatto */
    var c=document.querySelector('.ultra-cart-search-item[data-line-id="'+CSS.escape(key)+'"]');
    if(c)return c;
    /* Fallback: alcuni temi mettono data-line-id su un wrapper diverso */
    var any=document.querySelector('[data-line-id="'+CSS.escape(key)+'"]');
    if(any){
      return any.closest('.ultra-cart-search-item')||any;
    }
    return null;
  }
  function clearBundleStyling(){
    document.querySelectorAll('.fx-bundle-header,.fx-bundle-child-label').forEach(function(el){el.remove();});
    document.querySelectorAll('.ultra-cart-search-item[data-fx-bundle-child]').forEach(function(c){
      c.style.borderLeft='';c.style.marginLeft='';c.style.position='';c.style.boxShadow='';
      c.removeAttribute('data-fx-bundle-child');
    });
    document.querySelectorAll('.ultra-cart-search-item[data-fx-bundle-parent]').forEach(function(c){
      c.removeAttribute('data-fx-bundle-parent');
    });
  }
  function groupBundles(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(cart){
      if(!cart.items)return;
      var bundles={};
      cart.items.forEach(function(item){
        var bid=item.properties&&item.properties['_BundleId'];
        if(!bid)return;
        if(!bundles[bid])bundles[bid]=[];
        bundles[bid].push(item);
      });
      /* Pulisci styling vecchio se non ci sono più bundle */
      if(Object.keys(bundles).length===0){clearBundleStyling();return;}
      var cards=document.querySelectorAll('.ultra-cart-search-item');
      if(cards.length===0)return;
      /* Reset styling vecchio prima di riapplicare (gestisce reorder/cambio cart) */
      clearBundleStyling();
      Object.keys(bundles).forEach(function(bid){
        var group=bundles[bid];
        var parent=null,child=null;
        group.forEach(function(it){
          if(it.properties&&it.properties['_BundleParent'])child=it;else parent=it;
        });
        if(!parent||!child)return;
        var pc=findCardByKey(parent.key);
        var cc=findCardByKey(child.key);
        if(!pc||!cc)return;
        pc.setAttribute('data-fx-bundle-parent','1');
        cc.setAttribute('data-fx-bundle-child','1');
        var hdr=document.createElement('div');
        hdr.className='fx-bundle-header';
        hdr.style.cssText='background:#2D5A3D;color:#fff;padding:8px 14px;font-size:0.72rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em;border-radius:8px 8px 0 0;margin:0 0 4px;display:flex;align-items:center;gap:8px';
        hdr.innerHTML='<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>Set Doccia ad Angolo';
        pc.style.borderTop='none';
        pc.insertBefore(hdr,pc.firstChild);
        cc.style.boxShadow='inset 3px 0 0 #2D5A3D';
        cc.style.position='relative';
        var lbl=document.createElement('div');
        lbl.className='fx-bundle-child-label';
        lbl.style.cssText='background:rgba(45,90,61,0.08);color:#2D5A3D;padding:4px 14px;font-size:0.7rem;font-weight:700;text-transform:uppercase;letter-spacing:0.05em';
        lbl.textContent='↳ Parete laterale del set';
        cc.insertBefore(lbl,cc.firstChild);
        if(cc.previousElementSibling!==pc&&pc.parentNode===cc.parentNode){
          pc.parentNode.insertBefore(cc,pc.nextSibling);
        }
      });
    }).catch(function(){});
  }
  var _running=false;
  function runIt(){
    if(_running)return;
    _running=true;
    try{injectVariantOptions();groupBundles();}
    finally{setTimeout(function(){_running=false;},400);}
  }
  function init(){
    var drawer=document.getElementById('sidebar-cart');
    if(drawer){
      var ariaObs=new MutationObserver(function(muts){
        muts.forEach(function(m){
          if(m.attributeName==='aria-hidden'&&drawer.getAttribute('aria-hidden')==='false'){
            setTimeout(runIt,500);
          }
        });
      });
      ariaObs.observe(drawer,{attributes:true,attributeFilter:['aria-hidden']});
      var childObs=new MutationObserver(function(){
        clearTimeout(window._lacusBundleTimer);
        window._lacusBundleTimer=setTimeout(runIt,200);
      });
      childObs.observe(drawer,{childList:true,subtree:true});
    }
    [300,800,1500,3000].forEach(function(d){setTimeout(runIt,d);});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
  window.addEventListener('pageshow',function(){
    [100,500,1200].forEach(function(d){setTimeout(runIt,d);});
  });
  document.addEventListener('cart:updated',function(){setTimeout(runIt,300);});
})();
